/**
 * Inert stand-in for a native-only route file in the **web** bundle.
 *
 * expo-router enumerates routes with `require.context`, and its web regex
 * (`expo-router/_ctx.web.js`) matches `.*(?:\.android|\.ios|\.native)?\.[tj]sx?$` — where
 * the platform group is **optional rather than negated**. So `_layout.ios.jsx` satisfies
 * the *web* context and Metro pulls every native route file into the web graph. Worse,
 * their imports then resolve to `.web.jsx` variants, so native routes drag web-only code
 * in with them: that is how 257 KB of artifact editors stayed in entry after being made
 * lazy in the web layout.
 *
 * Substituting this file is safe because expo-router never evaluates those modules on web.
 * `getFileMeta` in getRoutesCore.js assigns `specificity = -1` to a platform extension
 * that does not match the target platform, and the caller does `if (meta.specificity < 0)
 * continue` **before** building the node's `loadRoute` closure. The module is bundled but
 * dead — which is exactly the waste, and exactly why replacing it changes no behaviour.
 *
 * See metro.config.js for the resolver rule, and docs/BUNDLE_SIZE_MAP.md §5a.
 */

// Returns null rather than throwing: this should be unreachable, but a route that renders
// nothing is a far better production failure than one that crashes the app.
export default function NativeOnlyRouteStub() {
  if (__DEV__) {
    console.warn(
      '[empty-route] A native-only route was rendered on web. This should be unreachable — '
      + 'check the platform-extension rule in metro.config.js.',
    );
  }
  return null;
}
